var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:no-coin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.81531 5.46665C3.05444 7.38529 2.07918 9.89578 2.08302 12.5C2.08302 18.2531 6.74656 22.9166 12.4997 22.9166C15.0377 22.9205 17.4892 21.994 19.3903 20.3125M22.1893 16.3312C22.6713 15.1115 22.918 13.8115 22.9164 12.5C22.9164 6.74685 18.2528 2.08331 12.4997 2.08331C11.2174 2.08331 9.98927 2.3156 8.85385 2.73956",
    stroke: "#FF6F82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.375 15.625C10.0458 16.5208 11.2948 17.0313 12.5 17.074M12.5 17.074C13.6604 17.1156 14.7812 16.724 15.3094 15.826M12.5 17.074V19.2708M9.89583 9.89583C9.89583 11.126 10.7833 11.6302 11.8604 11.9792M15.625 8.85417C14.9115 8.14062 13.6552 7.64479 12.5 7.61354V5.72917M3.125 3.125L21.875 21.875",
    stroke: "#FF6F82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoin);
export default __webpack_public_path__ + "static/media/no-coin.991e38ab649c82c18b6452f6ed7e395b.svg";
export { ForwardRef as ReactComponent };